import React, { useState } from 'react';
import Logo from '../Login/logowhite.png';
import { Loading } from '../../../Components';
import ReactGA from 'react-ga';
import { Link, useNavigate } from 'react-router-dom';
import styles from '../Login/style.module.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSubmit = async () => {
    setLoading(true);
    setMessage(null);
    setError(null);

    ReactGA.event({
      category: 'Botão',
      action: 'Clique',
      label: 'Enviar token de recuperação',
    });

    //

    try {
      const response = await fetch(`https://api.kollecta.io/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Token enviado por email. Verifique sua caixa de entrada.');
        navigate(`/inputToken?email=${encodeURIComponent(email)}`);
      } else {
        setError(data.message || 'Erro ao enviar token.');
      }
    } catch (err) {
      setError('Erro na requisição. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Loading show={loading}>
      <div className={styles.loginContainer}>
        <div className={styles.left}>
          <img src={Logo} alt="Logo" />
        </div>
        <div className={styles.right}>
          <div className={styles.cardForm}>
            <div className={styles.cardFormHeader}>
              <h4 className={styles.textInfo}>Recuperar Senha</h4>
              <p>Informe seu e-mail de cadastro para enviarmos o código de recuperação de senha.</p>
            </div>

            <div className={styles.inputsContainer}>
              <div className={styles.formGroup}>
                <label className={styles.formItem}>
                  E-mail *
                  <input
                    type="email"
                    placeholder="Digite o e-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>
              </div>
            </div>

            <div className={styles.actionContainer}>
              <button
                onClick={handleSubmit}
                className={styles.btnSubmit}
                disabled={loading || !email}
              >
                Enviar código de verificação
              </button>

              {message && <p className={styles.successMessage}>{message}</p>}
              {error && <p className={styles.errorMessage}>{error}</p>}

              <p className={styles.forgotPasswordLink}>
                <Link to="/login">Voltar para Login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Loading>
  );
};

export default ForgotPassword;
